import React from "react";
import '../../assets/css/buttons/RedButton.css';


const RedButton = ({setTrue, setFalseArr, onClickDo, fancyBorder=true, children}) => {
    const doSets = () => {
        console.log("doing sets");
        
        if(setTrue) {
            setTrue(true);  
        }
        
        if(setFalseArr && Array.isArray(setFalseArr)) {
            setFalseArr.forEach(setFalse => {
                setFalse(false);
            });
        }
    }

    return (
        <button 
            className={"flex flexCenter bigRedButton " + (fancyBorder ? "fancyRedBorder" : "regularRedBorder")} 
            type="button" 
            onClick={(e) => {
                if(onClickDo) {
                    onClickDo(e);
                }
                doSets();
            }}
        >
            {children}
        </button>
    );
}

export default RedButton;